module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-8.5fe97ed8.png";